import { useDispatch, useSelector } from 'react-redux';

import { setActivitiesCurrentPage } from '../../redux/actions';

export function useFilterParams() {
  const {
    activitiesPerPage: { data: perPage },
  } = useSelector((state) => state.activitiesReducer);
  const dispatch = useDispatch();

  const objectToParams = (obj) =>
    Object.entries(obj)
      .map(([key, value]) => `${key}=${value}`)
      .join('&');

  const updateSearchParam = (key, value) => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set(key, value);

    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.replaceState({}, '', newUrl);
  };

  const updateSearchParamsWithObject = (obj) => {
    const newParams = objectToParams(obj);
    const newUrl = `${window.location.pathname}?${newParams}`;
    window.history.replaceState(null, '', newUrl);
  };

  const formatFiltersForParams = ({ values } = {}) => {
    dispatch(setActivitiesCurrentPage({ data: 1 }));
    const newFilters = { page: 1, per_page: perPage };
    if (values.actions?.length) newFilters.actions = values.actions.join(',');
    if (values.locations?.length) newFilters.location_id = values.locations.join(',');
    if (values.performers?.length) newFilters.performer_id = values.performers.join(',');
    if (values.date_from) newFilters.date_from = values.date_from;
    if (values.date_to) newFilters.date_to = values.date_to;
    updateSearchParamsWithObject(newFilters);
  };

  return { formatFiltersForParams, updateSearchParam, updateSearchParamsWithObject };
}

export default useFilterParams;
